import { useEffect, useRef, useState } from 'react'

export function useInterval(callback: () => void, delay: number) {
    const savedCallback = useRef<() => void>()

    useEffect(() => {
        savedCallback.current = callback
    })

    useEffect(() => {
        function tick() {
            savedCallback.current && savedCallback.current()
        }

        const id = setInterval(tick, delay)
        return () => clearInterval(id)
    }, [delay])
}

export function useNow(interval = 1000) {
    const [now, setNow] = useState(Date.now())
    useInterval(() => setNow(Date.now()), interval)
    return now
}
